import React, { Component } from 'react'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal } from 'antd'
import { compose } from 'recompose'
import moment from 'moment'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { visible, onCancel, project } = this.props

		const images = project.project_attachments.map((attachment) => {
			return {
				original: `${process.env.REACT_APP_BACKEND_API}${attachment.url}`,
				thumbnail: `${process.env.REACT_APP_BACKEND_API}${attachment.url}`
			}
		})
		return (
			<Modal
				title='View Project Details'
				width='80%'
				visible={visible}
				onCancel={onCancel}
				destroyOnClose
				footer={null}
			>
				<Row type='flex' justify='center' gutter={24}>
					<Col md={18} sm={24}>
						<Row gutter={16}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Project Name</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{project.project_name}</h4>
							</Col>
						</Row>
					</Col>
					<Col md={18} sm={24}>
						<Row gutter={16}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Project Description</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{project.project_description}</h4>
							</Col>
						</Row>
					</Col>
					<Col md={18} sm={24}>
						<Row gutter={16}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Date Start</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{moment(project.date_start).format('ll')}</h4>
							</Col>
						</Row>
					</Col>
					<Col md={18} sm={24}>
						<Row gutter={16}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Date Accomplished</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{moment(project.date_end).isValid() ? moment(project.date_end).format('ll') : '- - -'}</h4>
							</Col>
						</Row>
					</Col>
					<Col md={18} sm={24}>
						<Row gutter={16}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Remarks</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{project.remarks}</h4>
							</Col>
						</Row>
					</Col>
				</Row>
				{
					(images.length > 0) &&
					<Row style={{ marginTop: 20 }}>
						<ImageGallery items={images} />
					</Row>
				}
			</Modal>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)